import { useQuery } from '@tanstack/react-query'
import { apiGet } from './api'

export interface CurrentUser {
  id: number
  email: string
  name: string
}

/** /api/auth/me — 401 시 apiFetch 가 refresh 시도 후 /login redirect. */
export function useCurrentUser() {
  return useQuery({
    queryKey: ['auth', 'me'],
    queryFn: () => apiGet<CurrentUser>('/api/auth/me'),
    retry: false,
    staleTime: 60_000,
  })
}
